module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "element element-non-bodymatter element-container-single element-type-foreword element-with-heading",
    attrs: {
      "id": "foreword"
    }
  }, [_c('div', {
    staticClass: "heading heading-with-title heading-without-image",
    attrs: {
      "id": "foreword-heading"
    }
  }, [_c('div', {
    staticClass: "heading-contents"
  }, [_c('div', {
    staticClass: "title-subtitle-block title-block-without-element-number"
  }, [_c('div', {
    staticClass: "element-number-block"
  }), _vm._v(" "), _c('div', {
    staticClass: "title-block"
  }, [_c('h1', {
    staticClass: "title"
  }, [_vm._v("Foreword")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "text",
    attrs: {
      "id": "foreword-text"
    }
  }, [_c('div', {
    staticClass: "blockquote-container prose without-attribution"
  }, [_c('blockquote', {
    staticClass: "prose without-attribution"
  }, [_c('p', {
    staticClass: "first blockquote-content blockquote-content-prose blockquote-position-first"
  }, [_c('i', [_vm._v("For every flower that grew in His garden, there was a seed. Some fell on good ground and their blossoms have their splendor. Others rode the wind and bloomed elsewhere to bring His message to the lost or fallen. And then, there were those with darker petals. They endured the bitter snows and blistering heat of adversity. In due season, nourished by the fertile ground of experience and a source everlasting, they too bloom. ")])]), _vm._v(" "), _c('p', {
    staticClass: "subsq blockquote-content blockquote-content-prose"
  }, [_c('i', [_vm._v("She is a rarity. Her color grows more radiant through the years. She nourishes the seedlings surrounding her from a well of hard-won wisdom. With leaves of green and veins of gold, their dark beauty is unmatched and so is her story.")])]), _vm._v(" "), _c('p', {
    staticClass: "subsq blockquote-content blockquote-content-prose blockquote-position-last"
  }, [_vm._v("—Stephanie M. Freeman, author of "), _c('i', [_vm._v("Necessary Evil")]), _vm._v(" and "), _c('i', [_vm._v("Nature of the Beast")])])])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2eaf5090","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/foreword.vue
// module id = 72
// module chunks = 0